export default async function fetchJson(
    request: RequestInfo,
    init?: RequestInit
): Promise<any> {
    const response = await fetch(request, init)
    const text = await response.text()

    if (response.ok) {
        if (response.status === 204 || text === '') {
            return undefined
        }

        try {
            return JSON.parse(text)
        } catch {
            throw new FetchError({
                message: 'Invalid JSON response',
                request,
                response,
                data: { message: 'Invalid JSON response' }
            })
        }
    }

    let data: unknown
    try {
        data = JSON.parse(text)
    } catch {
        data = undefined
    }

    throw new FetchError({
        message: response.statusText,
        request,
        response,
        data
    })
}

export class FetchError extends Error {
    response: Response
    request: RequestInfo
    data: unknown

    constructor({
        message,
        request,
        response,
        data
    }: {
        message: string
        request: RequestInfo
        response: Response
        data: unknown
    }) {
        super(message)

        if ((Error as any).captureStackTrace) {
            ;(Error as any).captureStackTrace(this, FetchError)
        }

        this.name = 'FetchError'
        this.response = response
        this.request = request
        this.data = data ?? { message }
    }
}
